import { createActions } from 'redux-actions';

export const { openDialog, closeDialog } = createActions(
  {
    OPEN_DIALOG: ({ id, body }, options = {}) => ({ id, body, options }),
  },
  'CLOSE_DIALOG',
);



// WEBPACK FOOTER //
// ./src/store/actions/Dialog/index.js